export const environment = {
  production: true,
  companyMetadata: {
    on_sale_generated_redirect_sale: true
  },
  companyConfiguration: {
    locale: 'es-ES',
    currency: 'EUR'
  },
  BEE_CLIENT_ID: "826b6a37-1d11-4725-94ab-cc67b493d186",
  BEE_CLIENT_SECRET: "Tn1FP7B9G1oIetrsdVT7rvKgct2pDCSduvbWGYJmZ4a8XmW1syc4"
};
